import {z} from 'zod';

import i18n from '@dms/i18n';

export const LabourCatalogueFormSchema = z.object({
  name: z.string().trim().min(1, i18n.t('general.validations.fieldIsRequired')),
  code: z.string().nullable().optional(),
  isEditable: z.boolean().nullable().optional(),
  authorizationProfiles: z.array(z.string().nullable()).optional(),
});

export type LabourCatalogueForm = z.infer<typeof LabourCatalogueFormSchema>;
